import React, { useEffect, useState, useRef } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import {
  Container,
  Col,
  Input,
  Row,
} from "reactstrap";

import search from "../../Assets/icons/Search.svg";
import { minuteDifference } from "../../utils/js/DateUtils";
import "./dashboard-header.scss";
import chatIcon from "../../Assets/icons/chaticon.svg"
import logo from "../../Assets/logo/logo.svg";
import bell from "../../Assets/icons/bell.svg";
import avatar from "../../Assets/icons/avatar.svg";
import { getNotifcations } from "../../services/getNotifications";
import history from "../../Assets/icons/history.svg";
import noNotifactionImg from "../../Assets/library-icons/no-notification.svg";
import { readNotification } from "../../services/readNotification";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoClose } from "react-icons/io5";

const DashboardHeader = ({setOpenSidebar}) => {
  const userEmail = localStorage.getItem("email");
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);
  const [prevSearchTerm, setPrevSearchTerm] = useState("");
  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [notificationMenuOpen, setNotificationMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const query = params.get("query");
    setSearchTerm(query || "");
  }, [location.search]);

  useEffect(() => {
    if (isSearchDropdownOpen || searchTerm.trim() !== "") {
      inputRef.current.focus();
    }
  }, [isSearchDropdownOpen, searchTerm]);

  const handleSearch = () => {
    if (searchTerm.trim() !== "") {
      if (searchTerm !== prevSearchTerm) {
        navigate(`/dashboard/subjects?query=${searchTerm}`);
        setPrevSearchTerm(searchTerm);
      }
    }
    setIsSearchDropdownOpen(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };



  const fetchNotificationData = async () => {
    const response = await getNotifcations();
    setNotificationData(response.data);
  };

  const handleMessageRead = async (id) => {
    const response = await readNotification(id);
    if (response.isSuccess) {
      fetchNotificationData();
    }
  };
  const notificationRef = useRef(null);

  const closeNotificationMenu = () => {
    setNotificationMenuOpen(false);
  };

 
  const handleClickOutside = (event) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target)
    ) {
      closeNotificationMenu();
    }
   
  };


  useEffect(() => {
    fetchNotificationData();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="top-header-dashboard">
        <RxHamburgerMenu
    size={25}
    className="d-md-none hamburger-icon1"                                                              
    color="black"
    onClick={() => setOpenSidebar(true)}
  />

        <div className="logo-dashboard">
          <img src={logo} alt="" width={"100%"} height={"100%"} />
        </div>
        {/* <div className="search-container d-none d-sm-block">
          <Row>
            <Col className="position-relative">
              <Input
                ref={inputRef}
                type="text"
                placeholder="Search.."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyPress}
                autoFocus={isSearchDropdownOpen || searchTerm.trim() !== ""}
                className="py-2 search inside"
                style={{height:"40px"}}
              />
              <div
                className="d-flex p-3 rounded-3 search-icon-main"
                onClick={handleSearch}
              >
                <img src={search} alt="" />
              </div>
            </Col>
          </Row>
        </div> */}
        <div className="d-flex  align-items-center justify-content-end gap-2 md:gap-3">


          <div className="px-3 notification-button" ref={notificationRef}>
            <span
              className="menu nav-link position-releative"
              onClick={() => setNotificationMenuOpen(!notificationMenuOpen)}
            >
              <img
                src={bell}
                alt=""
              />
              {notificationData.length > 0 && (
                <span className="notification-count">
                  {notificationData.length}
                </span>
              )}
            </span>
            <div
              className={`dropDown-Content ${notificationMenuOpen ? "open" : ""
                }`}
            >
              <div className="notification">
                <h3>Notification</h3>

                <div className="close">
                  <IoClose
                    size={20}
                    className="mb-2"
                    onClick={() => setNotificationMenuOpen(false)}
                  />
                </div>
              </div>
              <div className="pb-2 ps-3">
                {!notificationData.length ? (
                  <div className="d-flex flex-column align-items-center justify-content-center mt-5 mb-3">
      <img
        src={noNotifactionImg}
        alt="No Notification"
        style={{ width: "100px", opacity: "0.8",}}
      />

      <p className="mt-3 text-muted">
        No new notifications available
      </p>
    </div>
                ) : (
                  <></>
                )}
               


                <div className="notification-message-wrapper">
  {notificationData?.map((noti, index) => {
    return (
      <div
        key={noti._id}
        className={`notification-card ${index % 2 === 0 ? "purple" : "pink"}`}
      >
        <div className="notification-top">
          <div className="notification-id">{noti.displayId}</div>

          <div className="notification-time">
            {minuteDifference(noti.createdAt)}
          </div>
        </div>

        <div className="notification-title">
          {noti.title}
        </div>

        <div className="notification-desc">
          {noti.notificationStatus}
        </div>
        <div className="d-flex justify-content-end">
                            <button
                              className="read-button"
                              onClick={() => handleMessageRead(noti._id)}
                            >
                              Mark as Read
                            </button>
                          </div>
      </div>
    );
  })}
</div>

              </div>
            </div>
          </div>

          
          <div className="px-3 chat-button">
              <img
                src={chatIcon}
                alt=""
              />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardHeader;
